import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { useLandingConfig } from "../../hooks/useLandingConfig";
import { Save, MessageCircle } from "lucide-react";

export default function WhatsAppConfigPage() {
    const { config, setConfig, loading, saving, save } = useLandingConfig();

    if (loading) return <div className="text-gold-500">加载中...</div>;

    return (
        <div className="space-y-6" data-testid="whatsapp-config-page">
            <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                    <div className="text-xs font-semibold uppercase tracking-widest text-gold-500">落地页</div>
                    <h1 className="text-3xl font-bold tracking-tight text-slate-900 mt-1 flex items-center gap-3">
                        <MessageCircle className="h-7 w-7 text-gold-600" /> WhatsApp 客服
                    </h1>
                    <p className="text-sm text-gold-500 mt-1">
                        用于落地页付款成功弹窗上的「联系客服」按钮，随时可换号码与预设文案
                    </p>
                </div>
                <Button
                    data-testid="whatsapp-save-btn-top"
                    onClick={() => save()}
                    disabled={saving}
                    className="h-10 px-5 bg-gold-600 hover:bg-gold-700 text-white gap-2 shrink-0"
                >
                    <Save className="h-4 w-4" /> {saving ? "保存中..." : "保存"}
                </Button>
            </div>

            <Card className="p-6 border-slate-200 shadow-sm space-y-4" data-testid="lc-whatsapp-card">
                <div className="space-y-1.5">
                    <Label>WhatsApp 电话号码（含国际区号）</Label>
                    <Input
                        data-testid="lc-whatsapp-phone"
                        value={config.whatsapp_phone}
                        onChange={(e) => setConfig({ ...config, whatsapp_phone: e.target.value })}
                        placeholder="+60123456789"
                        className="font-mono"
                    />
                    <div className="text-xs text-gold-500">格式：<code className="bg-gold-50 px-1 rounded">+60</code> 开头，无空格无横线。用于 <code className="bg-gold-50 px-1 rounded">wa.me/</code> 链接。</div>
                </div>
                <div className="space-y-1.5">
                    <Label>预设消息内容</Label>
                    <Textarea
                        data-testid="lc-whatsapp-message"
                        rows={4}
                        value={config.whatsapp_message}
                        onChange={(e) => setConfig({ ...config, whatsapp_message: e.target.value })}
                        placeholder="您好，我刚在福缘珠宝下单..."
                    />
                    <div className="text-xs text-gold-500">
                        支持占位符 <code className="bg-gold-50 px-1 rounded">{"{invoice_no}"}</code>，会被自动替换成订单号。顾客点击 WhatsApp 按钮时，这段文字会预填在聊天框。
                    </div>
                </div>

                {/* Live preview */}
                <div className="pt-4 border-t border-slate-200">
                    <div className="text-xs font-semibold uppercase tracking-wider text-gold-600 mb-2">链接预览</div>
                    <div className="p-3 rounded-md bg-slate-900 text-xs font-mono text-emerald-300 break-all">
                        https://wa.me/{(config.whatsapp_phone || "").replace(/[^\d]/g, "")}?text={encodeURIComponent((config.whatsapp_message || "").replace("{invoice_no}", "FY-000001"))}
                    </div>
                    <div className="text-[10px] text-gold-500 mt-1">这就是顾客点击 WhatsApp 按钮时打开的实际链接（订单号已用示例 FY-000001 替换）。</div>
                </div>
            </Card>

            {/* Floating save button */}
            <div className="fixed bottom-6 right-6 z-40">
                <Button data-testid="whatsapp-save-btn" onClick={() => save()} disabled={saving}
                    className="h-12 px-6 bg-gold-600 hover:bg-gold-700 text-white gap-2 shadow-xl shadow-gold-900/20 rounded-full">
                    <Save className="h-4 w-4" /> {saving ? "保存中..." : "保存 WhatsApp"}
                </Button>
            </div>
        </div>
    );
}
